import * as React from 'react';
import { IntlService } from '../Intl/IntlService';
import { LocalizationService } from '../Localization/LocalizationService';
/** @hidden */
export var GlobalizationContext = React.createContext({
    intl: new IntlService('en'),
    localization: new LocalizationService()
});
//# sourceMappingURL=GlobalizationContext.js.map